module.exports = __webpack_public_path__ + "img/comingsoon_swap_1.2a317f24.png";